import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { PipesModule } from "../pipes/pipes.module";
import { BlockItemComponent } from "./block-item/block-item.component";
import { BuyVoucherListComponent } from "./buy-voucher-list/buy-voucher-list.component";
import { ClassTypeListComponent } from "./class-type-list/class-type-list.component";
import { StepItemComponent } from "./step-item/step-item.component";
import { StripeButtonModule } from "./stripe-button/stripe-button.module";
import { TrainingListModule } from "./training-list/training-list.module";
import { VoucherListComponent } from "./voucher-list/voucher-list.component";

@NgModule({
  declarations: [
    ClassTypeListComponent,
    VoucherListComponent,
    BuyVoucherListComponent,
    BlockItemComponent,
    StepItemComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    PipesModule,
    StripeButtonModule,
    TrainingListModule,
  ],
  exports: [
    ClassTypeListComponent,
    VoucherListComponent,
    BuyVoucherListComponent,
    BlockItemComponent,
    StepItemComponent,
  ],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/app/components/components.module.ts